import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="w-full px-6 py-4 md:py-5 bg-[#FAF7F2]" data-id="element-8">
      <motion.div className="max-w-3xl mx-auto text-center relative" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} data-id="element-9">
        {/* Subtle decorative line */}
        <div className="w-16 h-1 bg-[#C4A265] mx-auto mb-4 rounded-full opacity-60" data-id="element-10"></div>

        <p className="text-xl md:text-2xl font-serif italic text-[#1B2A4A] leading-relaxed" data-id="element-11">
          "Son las 7:30–9:30 pm. Solo quieres que todo termine en calma. Pero
          apagar el celular nunca es tan simple."
        </p>
      </motion.div>

      <motion.p className="text-center text-base md:text-lg text-[#3D3D3D] mt-6 mb-2 max-w-2xl mx-auto font-medium" initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-12">
        Pensado para casas reales, horarios reales y cansancio real.
      </motion.p>

      {/* Mockup image between empathy and product intro */}
      <motion.div className="mt-6 relative inline-block w-full text-center" initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} data-id="element-13">
        <div className="absolute inset-0 bg-[#C4A265] blur-3xl opacity-10 rounded-full transform scale-90 translate-y-4" data-id="element-14"></div>
        <img src="https://cdn.magicpatterns.com/uploads/pVDqYV9vw11wzhGcfeBRFs/mockoup_3.png" alt="Plan Anti-Pantalla Mockup en tablet" className="relative z-10 w-full max-w-[500px] mx-auto rounded-lg shadow-2xl shadow-[#1B2A4A]/10" data-id="element-15" />
      </motion.div>
    </section>;
}